// src/services/api.js - UPDATED WITH PLANNING METHODS
import axios from 'axios';
export { shopifyAPI } from './shopifyAPI';

const rawBase = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_BASE_URL = `${rawBase.replace(/\/$/, '')}/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login'; // ✅ Correct route
    }
    return Promise.reject(error);
  }
);

// Auth API functions
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verifyOtp: (data) => api.post('/auth/verify-otp', data),
  getMe: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
};

// Dashboard API functions
export const dashboardAPI = {
  getRealTimeInventory: () => api.get('/dashboard/real-time-inventory'),
  getWarehouseInventory: (warehouseId) => api.get(`/dashboard/warehouse/${warehouseId}/inventory`),
  getWarehouseConfig: () => api.get('/dashboard/warehouses/config'),
};

// Shipments API functions
export const shipmentsAPI = {
  getShipments: (params = {}) => api.get('/shipments', { params }),
  createShipment: (shipmentData) => api.post('/shipments', shipmentData),
  markAsArrived: (shipmentId) => api.put(`/shipments/${shipmentId}/arrive`),
};

// Users API functions (admin only)
export const usersAPI = {
  getUsers: (params = {}) => api.get('/users', { params }),
  createUser: (userData) => api.post('/users', userData),
  updateUser: (userId, userData) => api.put(`/users/${userId}`, userData),
  deleteUser: (userId) => api.delete(`/users/${userId}`),
  getUserStats: () => api.get('/users/stats/overview'),
  activateUser: (userId) => api.put(`/users/${userId}/activate`),
};

// Planning API functions - UPDATED WITH ALL METHODS
export const planningAPI = {
  // Dashboard API
  getPlanningDashboard: (dateRange = {}) => api.get('/planning/dashboard', { params: dateRange }),

  // Sales Planning APIs
  getSalesPlans: (params = {}) => api.get('/planning/sales', { params }),
  createSalesPlan: (planData) => api.post('/planning/sales', planData),
  updateSalesPlan: (date, planData) => api.put(`/planning/sales/${date}`, planData),
  deleteSalesPlan: (date) => api.delete(`/planning/sales/${date}`),

  // Manufacturing Planning APIs
  getManufacturingPlans: (params = {}) => api.get('/planning/manufacturing', { params }),
  createManufacturingPlan: (planData) => api.post('/planning/manufacturing', planData),
  updateManufacturingPlan: (date, planData) => api.put(`/planning/manufacturing/${date}`, planData),
  deleteManufacturingPlan: (date) => api.delete(`/planning/manufacturing/${date}`),

  // Actual Data APIs
  getActualData: (params = {}) => api.get('/planning/actual', { params }),
  createActualData: (actualData) => api.post('/planning/actual', actualData),
  updateActualData: (date, actualData) => api.put(`/planning/actual/${date}`, actualData),

  // Legacy APIs (for backwards compatibility)
  getManufacturingPlan: () => api.get('/planning/manufacturing-plan'),
  getManufacturingVsActual: () => api.get('/planning/manufacturing-vs-actual'),
  getSalesPlan: () => api.get('/planning/sales-plan'),
  getSalesVsActual: () => api.get('/planning/sales-vs-actual'),
};

export default api;